/////////////////////////////////////////////
///////////// Hero slider  //////////////////
///////////////////////////////////////////
(function($){

    const slideParamsAutoplay = slideParams.get('autoplay') ? slideParams.get('autoplay') : false
    const slideParamsDelay = slideParams.get('delay') ? slideParams.get('delay') : 4000
        
    $('#HeroSlider').bxSlider({
        mode:'fade',
        auto: slideParamsAutoplay,
        pause: slideParamsDelay,
        slideWidth:1000,
        minSlides:1,
        maxSlides:1,
        moveSlides:1,
        slideMargin:0,
        pager: true,
        //pagerCustom: '#bx-pager',
        captions: true,
        controls: false
    });

})(jQuery);


/////////////////////////////////////////////
/////////////Social stream////////////////////
///////////////////////////////////////////
if($('#rezo-stream-autrement').length){
    $('#rezo-stream-autrement').dcSocialStream({
        feeds: {
            facebook: {
                id: '251454736376',
                image_width: 2,
                feed: 'posts',
                url: apidae.base_url + 'facebook.php'
                //text: 'contentSnippet',
            }
        },
        rotate: {
            direction: 'up',
            delay: 6000
        },
        control: false,
        filter: true,
        //centre: true,
        wall: false,
        cache: false,
        max: 'limit',
        days: 30,
        limit: 3,
        iconPath: 'assets/img/rezo/dcsns-light/',
        imagePath: 'assets/img/rezo/dcsns-light/'
    });
};


if($('#rezo-stream-passion').length){
    $('#rezo-stream-passion').dcSocialStream({
        feeds: {
            facebook: {
                id: '785419208190396',
                image_width: 2,
                feed: 'posts',
                url: apidae.base_url + 'facebook.php'
                //text: 'contentSnippet',
            }
        },
        rotate: {
            direction: 'up',
            delay: 9000
        },
        control: false,
        filter: true,
        //centre: true,
        wall: false,
        cache: false,
        max: 'limit',
        days: 30,
        limit: 3,
        iconPath: 'assets/img/rezo/dcsns-light/',
        imagePath: 'assets/img/rezo/dcsns-light/'
    });
};